<template>
    <!-- identity dialog -->
    <el-dialog title="Confirm Your Identity" width="620" v-model="identityDialogOpen"
        @close="identityDialogOpen = false" class="handle-dialog">
        <Loading v-if="is_loading" />
        <div class="step-1" v-if="identityDialog === 1">

            <label>Please enter your current password</label>
            <div class="input-box">
                <el-input id="identity-code" v-model="identityValue.password" :type="is_show_password ? 'text' : 'password'"
                    placeholder="******"></el-input>
                <i @click="is_show_password = !is_show_password">
                    <svg-icon v-if="!is_show_password" name="eye-hidden" />
                    <svg-icon v-else name="eye" />
                </i>
            </div>
            <div class="err-text" v-if="identityErr.password">{{ identityErr.password }}</div>
        </div>
        <div class="step-2" v-else>
            <p>We have sent a 6-digit verification code to your login email. This code will expire in 5 minutes.</p>
            <div class="label-line">
                <label>Enter code</label>
                <div class="el-link" @click="callSixDigitApi()">Resend</div>
            </div>
            <el-input id="identity-code" v-model="identityValue.code" type="text" maxlength="6"
                placeholder="Enter verification code"></el-input>
            <div class="err-text" v-if="identityErr.code">{{ identityErr.code }}</div>
        </div>
        <div class="btn-row">
            <el-button @click="identityDialogOpen = false" type="text">Cancel</el-button>
            <el-button type="primary" @click="handleIdentityDialog()"
                :disabled="identityDialog === 1 ? !identityValue.password : !identityValue.code">{{
                    identityDialog === 1 ? 'Next' : 'Confirm' }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Scrollbar from '@/components/ui/Scrollbar.vue';
import { ElSelect, ElOption, ElButton, ElDialog, ElInput } from 'element-plus';
import Loading from '@/components/ui/Loading.vue';

export default {
    name: 'Team',

    components: {
        Scrollbar,
        ElSelect,
        ElOption,
        ElButton,
        ElDialog,
        ElInput,
        Loading
    },

    props: {
        handleDialog: {
            type: Number,
            default: 1
        },
    },

    data() {
        return {
            is_loading: false,
            handleNowUser:null,
            identityDialogOpen: false,
            identityDialog: 1,
            identityValue: {
                password: '',
                code: ''
            },
            identityErr: {
                password: '',
                code: ''
            },
            is_show_password: false,
            isDelete: false,
        }
    },

    computed: {
    },

    methods:{
        open(type,now,spec) {
            this.identityValue.password = '';
            this.identityValue.code = '';
            this.identityErr.password = '';
            this.identityErr.code = '';
            this.identityDialog = type;
            this.handleNowUser=now;
            this.identityDialogOpen = true;
            this.isDelete = spec ? true : false;
        },
        close(){
            this.identityDialogOpen = false;
            this.identityValue.password = '';
            this.identityValue.code = '';
            this.identityErr.password = '';
            this.identityErr.code = '';
        },
        callSixDigitApi() {
            this.is_loading = true;
            this.$ajax.get(`/settings/send-owner-transfer-email?target_portal_user_id=${this.handleNowUser.id}`).then(res => {
                this.is_loading = false;
                this.identityDialog = 2;
            })
        },
        async handleIdentityDialog() {
            if (this.identityDialog === 1) {
                this.checkPasswordApi();
            } else {
                if (this.handleDialog === 3) {
                    this.transferOwnerApi('leave');
                } else {
                    this.transferOwnerApi();
                }
            }
        },

        checkPasswordApi() {
            this.is_loading = true;
            let formData = new FormData();
            formData.append('password', this.identityValue.password);

            this.$ajax.post(`/settings/check-owner-password`, formData).then(res => {
                this.identityErr.password = '';
                this.callSixDigitApi();
            }).catch(err => {
                console.log(err);
                this.identityErr.password = err.response && err.response.data.data ? err.response.data.data.message : 'Incorrect password. Please try again.';   
                this.is_loading = false;
            });
        },

        transferOwnerApi(val) {
            this.is_loading = true;
            let formData = new FormData();
            formData.append('password', this.identityValue.password);
            formData.append('code', this.identityValue.code);
            formData.append('target_portal_user_id', this.handleNowUser.id);
            this.$ajax.post(`/settings/transfer-owner`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                this.successNofity(`Transfer ownership successfully`);
                
                if(this.isDelete){
                    this.delUser();
                    return;
                };

                if (val === 'leave') {
                    this.removeUser(this.$store.state.user_data.id);
                } else {
                    //權限轉移要重新CALL ME
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }

            }).catch(err => {
                let errMes = err.response && err.response.data.data ? err.response.data.data.message : '';
                this.identityErr.code = errMes ? errMes : 'The code you entered could not be verified.';
                this.is_loading = false;
            });
        },
        successNofity(mes) {
            this.$notify({
                text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                    </svg> ${mes}.`,
                group: 'white',
                type: 'success',
            });
        },
        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify({
                text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
                </svg>
                ${mes}`,
                group: 'white',
                type: 'warn',
            });
        },
        removeUser(id) {
            this.is_loading = true;
            let formData = new FormData();
            formData.append('remove_portal_user_id', id);

            this.$ajax.post(`/settings/remove-merchant-user`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                this.identityDialogOpen = false;
                this.successNofity(`Remove user successfully`);
                if (this.$store.state.user_data.id == id) {
                    setTimeout(e => {
                        window.location.href = '/landing';
                    }, 1000);
                    return;
                }
                this.$emit('remove-user');

            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        delUser(){
            this.is_loading = true;
            this.$ajax('/settings/login-user-delete-account', {
                method: 'post',
            }).then(res => {
                this.successNofity(`Leave successfully.`);
                setTimeout(() => {
                    this.is_loading = false;
                    this.$router.replace('/logout');
                }, 2000);

            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data) {
                    this.errNofity(err);
                }
            });
        },
    },

    mounted() {

    },
}
</script>
<style lang="scss">

.handle-dialog {
    .btn-row {
        margin-top: 16px;
        display: flex;
        gap: 8px;
        justify-content: flex-end;
    }

    label {
        margin: 8px 0;
    }

    .el-select {
        margin: 16px 0;
    }

    .err-text {
        color: var(--red);
        margin-top: 4px;
        text-align: right;
    }

    .step-1 {
        .input-box {
            position: relative;
            margin-top: 8px;
            width: 100%;
        }

        i {
            position: absolute;
            right: 16px;
            top: 8px;
            cursor: pointer;

            svg {
                width: 16px;
                height: 16px;
            }
        }
    }

    .step-2 {
        p {
            font-size: 16px;
        }

        .label-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;

            .el-link {
                color: var(--blue);
                cursor: pointer;
            }
        }
    }
}
</style>
